import React, { useEffect, useState } from 'react'
import { db } from '../firebase'
import { onSnapshot, collection, query, limit, orderBy } from "firebase/firestore"
import Loader from '../component/ui/Visual-utilities/Loader';
import Card from '../component/ui/Card';
import { HiOutlineStatusOnline } from 'react-icons/hi'
import d21 from './Webinars.module.css'

import RequestWebinarform from '../component/RequestWebinarform';

//import { UserContext } from '../store/UserContext';
function Webinars() {
    // let  userCtx=useContext(UserContext);
//let userData=userCtx.user;

    const WebinarsCollectionRef = collection(db, 'webinars')
    const [webinars, setWebinars] = useState([]);
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {//called immidiately when the page loads

        let isMounted = true;//clean up
        setIsLoading(true);
        try {
            const q = query(WebinarsCollectionRef, orderBy('startsAt', 'asc'), limit(40));

            const getusers = () => {
                onSnapshot(q,
                    snapshot => {
                        if (isMounted) {
                            setWebinars(snapshot.docs.map((docu) => ({ ...docu.data(), webinar_id: docu.id })))
                            setIsLoading(false);
                        }
                    }
                );
            }
            getusers();
        }
        catch (e) { console.log(e) }
        return () => { isMounted = false };//clean up function call
    }, [])




    return (

        <div >
            {isLoading && <Loader />}
            <section>
                <center style={{ 'color': 'grey' }}> <b>Do you have a near exam?</b><br />
                    Wish to have a webinar support in certain subjects? </center>

                <RequestWebinarform />
            </section>
            <hr />
            <section>

                <center style={{ 'color': '#0C76FF' }}> <b >Current Webinars</b> </center>
                {webinars.length === 0 && 'no webinars yet'}
                {webinars.map((n, index) => {

                    return <a href={n.link} rel="noreferrer" target='_blank' key={index}> <Card>
                        <div className={d21.webinarMainContainer}>
                            <div className={d21.icon}><HiOutlineStatusOnline size='55' /></div>

                            <div className={d21.content}>
                                <h4>{n.title}</h4>
                                <div className={d21.preVal}>For: &nbsp;  <div className={d21.Val}> {n.grade}</div></div>
                                <div className={d21.preVal}>In: &nbsp; <div className={d21.Val}> {n.subject}</div></div>
                                <div className={d21.preVal}>Starts at: &nbsp; <div className={d21.Val}> {n.startsAt && n.startsAt.toDate().toString().substring(0, 21)}</div></div>
                            </div></div>
                    </Card> </a>
                }, this)}
            </section>
        </div>
    )
}

export default Webinars
